import PageTemplate from './PageTemplate';
import './ModulePage.css';

function Settings() {
  return (
    <PageTemplate
      title="Settings"
      subtitle="Configure platform and integrations"
    >
      <div className="module-placeholder">
        <div className="settings-sections">
          <div className="settings-section">
            <h3>General</h3>
            <p>Platform name, logo, and basic configuration</p>
          </div>
          <div className="settings-section">
            <h3>Branding</h3>
            <p>Colors, themes, and custom styling</p>
          </div>
          <div className="settings-section">
            <h3>Integrations</h3>
            <p>Payment gateways, email, analytics</p>
          </div>
          <div className="settings-section">
            <h3>Security</h3>
            <p>Authentication, roles, and permissions</p>
          </div>
        </div>
      </div>
    </PageTemplate>
  );
}

export default Settings;
